class ClassBurger {
  constructor(
    label,
    onClass = "open",
    callback = function () {
      return true;
    }
  ) {
    this.label = label;
    this.onClass = onClass;

    if (this.dialogs.length > 0) {
      // Bind toggles and dialogs
      this.bindTrigger(this.dialogs, this.toggles, label, onClass, callback);

      // Bind click handler for closing if clicking outside the hamburger menu
      document.addEventListener("click", this.handleOutsideClick);
    } else {
      console.error("Dialog element with value " + label + " does not exist.");
    }
  }

  get dialogs() {
    return document.querySelectorAll(
      "[data-hamburger-dialog=" + this.label + "]"
    );
  }

  get toggles() {
    return document.querySelectorAll(
      "[data-hamburger-toggle=" + this.label + "]"
    );
  }

  handleOutsideClick = (event) => {
    const content = [...this.dialogs];
    const toggles = [...this.toggles];
    if (
      !content?.some((el) => el.contains(event.target)) &&
      !toggles?.some(
        (el) => el === event.target || el === event.target.parentNode
      ) &&
      content?.some((el) => el.classList.contains("active"))
    ) {
      console.info("handleOutsideClick");
      this.closeDialogs();
    }
  };

  handleMutationObserver = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (
        mutation.type !== "attributes" &&
        mutation.attributeName !== "aria-expanded"
      )
        return;
      const toggle = mutation.target;
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";

      const body = document.querySelector("body");
      const id = toggle.dataset.hamburgerToggle;
      const dialog = document.querySelector(`[data-hamburger-dialog=${id}]`);
      dialog?.classList.toggle(this.onClass, isExpanded);
      dialog?.toggleAttribute("inert", !isExpanded);
      body?.classList.toggle("has-scroll-lock", isExpanded);
      toggle.classList.toggle(this.onClass, isExpanded);
    }
  };

  handleFocusOut = (event) => {
    if (
      !!event.relatedTarget &&
      ![...this.dialogs].some((el) => el.contains(event.relatedTarget)) &&
      ![...this.toggles].some((el) => el.contains(event.relatedTarget))
    ) {
      this.closeDialogs();
    }
  };

  closeDialogs = () => {
    this.toggles?.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false");
    });
  };

  handleToggleClick = (event) => {
    const button = event.currentTarget;
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", `${!isExpanded}`);
  };

  handleKeyDown = (event) => {
    // const dialog = event.currentTarget;
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      this.closeDialogs();
      this.toggles[0].focus();
    }
  };

  bindTrigger(dialogs, toggles, label, onClass) {
    const observer = new MutationObserver(this.handleMutationObserver);

    if (toggles.length > 0) {
      // Bind click handler
      [...toggles].forEach((toggle) => {
        toggle.addEventListener("click", this.handleToggleClick);
        observer.observe(toggle, {
          attributes: true,
          attributeFilter: ["aria-expanded"],
        });
      });
      [...dialogs].forEach((node) => {
        node.addEventListener("keydown", this.handleKeyDown);
        node.addEventListener("focusout", this.handleFocusOut);
        node.setAttribute("inert", true);
        const links = node.querySelectorAll("a");
        links.forEach((link) => {
          link.addEventListener("click", this.closeDialogs);
        });
      });
    } else {
      console.error(
        "Toggle matching dialog element value" + label + "does not exist"
      );
    }
  }
}

export default ClassBurger;
